import { render, staticRenderFns } from "./IresDeviceSampleList.vue?vue&type=template&id=6f683baf&scoped=true&"
import script from "./IresDeviceSampleList.vue?vue&type=script&lang=ts&"
export * from "./IresDeviceSampleList.vue?vue&type=script&lang=ts&"
import style0 from "./IresDeviceSampleList.vue?vue&type=style&index=0&id=6f683baf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f683baf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
